import { render } from "./HistoryActions.vue?vue&type=template&id=7e4df324"
import script from "./HistoryActions.vue?vue&type=script&lang=js"
export * from "./HistoryActions.vue?vue&type=script&lang=js"
script.render = render

export default script